import { BrowserRouter as Router, Route, Routes } from 'react-router';
import LandingPage from './components/LandingPage';
import SalesPage from './components/SalesPage';
import SalesDetailsPage from './components/SalesDetailsPage';
import ProductPage from './components/ProductPage';
import CustomerPage from './components/CustomerPage';
import ExpensePage from './components/ExpensePage';
import TransactionsPage from './components/TransactionsPage';
import ProfitReport from './components/ProfitReportPage';
import LoginPage from './components/LoginPage';
import PrivateRoute from './components/PrivateRoute';
import NotFoundPage from './components/NotFoundPage';
import AnalyticsPage from './components/AnalyticsPage';
import DailySalesAnalysis from './components/DailySalesAnalysis';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><LandingPage /></PrivateRoute>} />
        <Route path="/sales" element={<PrivateRoute><SalesPage /></PrivateRoute>} />
        <Route path="/sales/:saleId" element={<PrivateRoute><SalesDetailsPage /></PrivateRoute>} />
        <Route path="/products" element={<PrivateRoute><ProductPage /></PrivateRoute>} />
        <Route path="/expenses" element={<PrivateRoute><ExpensePage /></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><CustomerPage /></PrivateRoute>} />
        <Route path="/transactions" element={<PrivateRoute><TransactionsPage /></PrivateRoute>} />
        <Route path="/profit-reports" element={<PrivateRoute><ProfitReport /></PrivateRoute>} />
        <Route path="/daily-analysis" element={<PrivateRoute><DailySalesAnalysis /></PrivateRoute>} />
        <Route path="/analytics" element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
        <Route path="*" element={<PrivateRoute><NotFoundPage /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
